import { render, staticRenderFns } from "./NewsOwner.vue?vue&type=template&id=3c2448a0&scoped=true&"
import script from "./NewsOwner.vue?vue&type=script&lang=js&"
export * from "./NewsOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2448a0",
  null
  
)

export default component.exports